
import gql from "graphql-tag";

const GIS_HOUSE_PREVIOUS_ACTIVATION_STATUS = gql`
    query GisHousePreviousActivationStatus($house_id: ID!, $apartment: String) {
        gis_house_previous_activation_status(house_id: $house_id, apartment: $apartment) {
            previous_activation_status,
            msisdn_with_max_last_rc_date
        }
    }
`;

const CHECK_GIGABIT_ELIGIBILITY = gql `
    query CheckGigabitEligibility($flat_number: String, $zip_code: String){
        gis_flats(flat_number: $flat_number,zip_code:$zip_code){
            is_1g_available
    }  
}
`;

const CRAMER_CHECK = gql `
    query CramerCheck($msisdn: String!){
        fttb_gigabit_status(msisdn: $msisdn){
            status
    }
}
`;

const CHECK_GPON_AVAILABILITY = gql`
    query GponStatus($street_id: String!) {
        gpon_details(street_id: $street_id) {
            cid
            private_sector
            network_type
            error_code
            error_message
        }
    }
`;

const CREATE_NEW_HOUSE = gql`
    mutation createNewHouse($street_id: String!, $city_id: String!, $house_number: String!, $flat_number: String, $user_name: String!) {
        fttb_house_provisioning(street_id: $street_id, city_id: $city_id, house_number: $house_number, flat_number: $flat_number, user_name: $user_name) {
            cid
            house_id
            house_num
            fttb_available
            network_type_id
            flats {
                flat_id
                flat_num
            }
            status
        }
    }
`;

export {
	GIS_HOUSE_PREVIOUS_ACTIVATION_STATUS,
	CHECK_GIGABIT_ELIGIBILITY,
	CRAMER_CHECK,
    CHECK_GPON_AVAILABILITY,
    CREATE_NEW_HOUSE
};
